import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import AAAGSDetailsFilter from "./AAAGSDetailsFilter";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import { attendanceGet } from "../../../data/ApiEndpoints";
import { convertStraight, convertToYYYYMMDD } from "../../common-data/Converts";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import CheckinReports from "../../trainer-report/common/CheckinReports";

const AAAGADetails = ({ userInfoData, clickedCard, prevFilters }) => {
  const dispatch = useDispatch();
  const { dataDup, loading } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const initialFilters = { searchString: "" };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    search: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    isModOpen: false,
    userId: "",
    type: "",
    clickedType: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getData() {
    const { date_from, date_to, ...rest } = prevFilters;

    const updatedFilters = {
      ...filters,
      account_type: clickedCard.cardTag,
      date_from: convertStraight(date_from),
      date_to: convertStraight(date_to),
      ...rest,
    };

    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: attendanceGet,
        payload: {
          filters: updatedFilters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    if (filters) {
      getData();
    }
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (dataDup?.status && dataDup?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup.data,
        pagination: dataDup?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150" style={{ textAlign: "center" }}>
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "Info",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.user_id,
                type: row?.role || "",
                clickedType: "last_checkin",
                sendableStatsQPs: row?.checkin_date
                  ? `&start_date=${
                      convertToYYYYMMDD(row.checkin_date) || ""
                    }&end_date=${convertToYYYYMMDD(row.checkin_date) || ""}`
                  : "",
              }))
            }
          >
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.role !== "guest" ? row?.email || "" : null}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "checkin_date",
      text: "checkin date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.checkin_date || "-"}
          </span>
        );
      },
    },
    {
      dataField: "time",
      text: "checkin time",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.time || "-"}</span>;
      },
    },
  ];

  return (
    <>
      <AAAGSDetailsFilter
        userInfoData={userInfoData}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickReset={onClickReset}
      />

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="tab-view-table-container overflowAuto separatedTable  mt30">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        </div>
      )}

      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${clickValues.clickedType?.replace(/_/g, " ")} - ${
              clickValues.type === "receptionist"
                ? "Sales Executive"
                : clickValues.type || ""
            }`}
            onClose={onCloseModal}
          />

          {clickValues.clickedType === "last_checkin" ? (
            <>
              {clickValues.type === "trainer" ||
              clickValues.type === "receptionist" ? (
                <CheckinReports
                  clickValues={clickValues}
                  sendableStatsQPs={clickValues.sendableStatsQPs}
                  lastCheckinTRDate={true}
                />
              ) : (
                <MemberCheckinLogs
                  clickValues={clickValues}
                  sendableStatsQPs={clickValues.sendableStatsQPs}
                  lastCheckinTRDate={true}
                />
              )}
            </>
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default AAAGADetails;
